import ReportBusiness from './reportBusiness'
export default ReportBusiness
